import { useEffect, useState } from 'react';
import { safeImageSrc } from './safeImageSrc';
import { useIsDemoMode } from '../../../data/hooks/ui/useIsDemoMode';

/**
 * Verifies that src loads before using it, falling back to altSrc otherwise.
 * Returns altSrc immediately while the check is in flight.
 *
 * @param {string} src - Preferred image URL.
 * @param {string} [altSrc] - Fallback URL used until/unless src is confirmed to load.
 * @returns {string} The current best-known safe URL.
 */
export const useSafeImageSrc = (src, altSrc) => {
    const [checkedSrc, setCheckedSrc] = useState(altSrc);

    useEffect(() => {
        if (src) {
            let mounted = true;

            (async () => {
                let checkedSrc = await safeImageSrc(src, altSrc);
                if (mounted) setCheckedSrc(checkedSrc);
            })();

            return () => (mounted = false);
        } else setCheckedSrc(altSrc);
    }, [src, altSrc]);

    return checkedSrc;
};
